import { useState } from 'react';
import React from 'react';

import VerifyCode from './VerifyCode';
import VerifyEmail from './VerifyEmail';

interface VerifyProps {
  share_id: string;
  onVerified: (token: string) => void;
}

enum VerifyStep {
  Email = 0,
  Code = 1,
}
function Verify({ share_id, onVerified }: VerifyProps) {
  const [step, setStep] = useState(VerifyStep.Email);
  const [email, setEmail] = useState<string>('');

  const handleEmailComplete = (email: string) => {
    setEmail(email);
    setStep(VerifyStep.Code);
  };

  const handleCodeComplete = (token: string) => {
    onVerified(token);
  };

  const handleReset = () => {
    setStep(VerifyStep.Email);
    setEmail('');
  };

  return (
    <>
      {step === VerifyStep.Email && (
        <VerifyEmail share_id={share_id} onComplete={handleEmailComplete} />
      )}
      {step === VerifyStep.Code && email && (
        <VerifyCode
          share_id={share_id}
          email={email}
          onComplete={handleCodeComplete}
          onReset={handleReset}
        />
      )}
    </>
  );
}

export default Verify;
